import React from 'react';
import {OperatorTriggerInsight} from "types/OperatorInsights";
import {ChartData, ChartOptions} from "chart.js";
import {Pie as PieChart} from "react-chartjs-2";
import {DateTime} from "luxon";

// Types ----

type HourlyTriggerExecutionsChartProps = {
  data: OperatorTriggerInsight
}

// Helpers ----

function localHour(hour: number): number {
  const localHour = hour + Math.round(DateTime.now().offset / 60);

  return localHour > 23 ? localHour - 24 : localHour;
}

// Component ----

function HourlyTriggerExecutionsChart({data}: HourlyTriggerExecutionsChartProps) {

  const hourlyTriggerExecutions = data.summary.hourly_trigger_executions;

  const chartData: ChartData<'pie', any> = {
    labels: hourlyTriggerExecutions.map(hour => `${localHour(hour.hour)}:00`),
    datasets: [{
      label: "Trigger executions per hour",
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
        'rgb(216, 119, 236, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
        'rgb(216, 119, 236, 1)',
      ],
      borderWidth: 1,
      data: hourlyTriggerExecutions.map(hour => hour.total_executions)
    }],
  }

  const chartOptions: ChartOptions<'pie'> = {
    plugins: {
      legend: {
        display: true,
      }
    },
    radius: '90%',
    maintainAspectRatio: false
  }

  return (
    <PieChart data={chartData} options={chartOptions}/>
  );
}

export default HourlyTriggerExecutionsChart;